import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Avatar, AvatarFallback } from './ui/avatar';

export const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      name: "Maria Silva",
      role: "Mãe do João - Maternal",
      text: "Meu filho ama a escolinha! A equipe é maravilhosa e o desenvolvimento dele tem sido incrível. Recomendo de olhos fechados!"
    },
    {
      id: 2,
      name: "Carlos Santos",
      role: "Pai da Ana - Educação Infantil",
      text: "Ambiente acolhedor e seguro. As professoras são dedicadas e carinhosas. A Ana sempre chega em casa feliz e cheia de novidades!"
    },
    {
      id: 3,
      name: "Juliana Oliveira",
      role: "Mãe do Pedro - Berçário",
      text: "Confiamos plenamente na equipe. O cuidado com os bebês é excepcional e as instalações são impecáveis. Melhor escolha que fizemos!"
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-gradient-to-b from-amber-50/50 via-white to-amber-50/50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block mb-4">
            <span className="text-amber-600 font-semibold text-sm uppercase tracking-wider bg-amber-100 px-4 py-2 rounded-full">
              Depoimentos
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            O Que Dizem Nossos Pais
          </h2>
          <p className="text-lg text-gray-600">
            A satisfação das famílias é nosso maior orgulho
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <Card 
              key={testimonial.id}
              className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-amber-200 bg-white relative overflow-hidden"
            >
              {/* Decorative Quote */}
              <div className="absolute top-4 right-4 text-amber-200 opacity-30 group-hover:opacity-40 transition-opacity">
                <Quote size={80} fill="currentColor" />
              </div>

              <CardContent className="p-6 relative z-10">
                {/* Stars */}
                <div className="flex gap-1 mb-4">
                  <Star size={18} className="text-amber-400 fill-amber-400" />
                  <Star size={18} className="text-amber-400 fill-amber-400" />
                  <Star size={18} className="text-amber-400 fill-amber-400" />
                  <Star size={18} className="text-amber-400 fill-amber-400" />
                  <Star size={18} className="text-amber-400 fill-amber-400" />
                </div>

                {/* Testimonial Text */}
                <p className="text-gray-700 mb-6 leading-relaxed italic">
                  "{testimonial.text}"
                </p>

                {/* Author */}
                <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                  <Avatar className="w-12 h-12 border-2 border-amber-200">
                    <AvatarFallback className="bg-gradient-to-br from-amber-400 to-orange-400 text-white font-semibold">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                  </Avatar>
                  <div>
                    <div className="font-semibold text-gray-800">{testimonial.name}</div>
                    <div className="text-sm text-gray-500">{testimonial.role}</div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-16 text-center">
          <Card className="inline-block bg-gradient-to-r from-amber-50 to-orange-50 border-amber-200 shadow-lg">
            <CardContent className="p-6 flex items-center gap-4">
              <div className="bg-gradient-to-br from-amber-400 to-orange-400 p-3 rounded-full">
                <Star className="text-white fill-white" size={24} />
              </div>
              <div className="text-left">
                <div className="text-2xl font-bold text-gray-800">5.0 Estrelas</div>
                <div className="text-gray-600">Avaliação média das famílias</div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
